import { render, staticRenderFns } from "./SosLoginField.vue?vue&type=template&id=a05eccec&lang=pug"
import script from "./SosLoginField.vue?vue&type=script&lang=js"
export * from "./SosLoginField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports